import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import axios from 'axios';
import { Spinner } from "reactstrap";
import { useSelector } from "react-redux";
import jwtDecode from 'jwt-decode'

export const FlowEmeraldLink = () => {
  const { t } = useTranslation()
  const [isLoading, setIsLoading] = useState(false)
  
  const slug = useSelector((state) => {
    const token = state.Login.data.Authorization.replace('Bearer ', '');
    const tokenDecoded = jwtDecode(token)
    return tokenDecoded.userClient
  });

  const handleClick = useCallback(async () => {
    setIsLoading(true)
    const response = await axios.post('/auth/grant-type/authorization-code').finally(() => setIsLoading(false));
    const { data: { hash } } = response.data;
    window.open(`${process.env.REACT_APP_FLOW_EMERALD_APP_URL}?code=${hash}&slug=${slug}`, '_blank').focus()
  }, [slug])

  return (
    <Link to='#' onClick={handleClick}>
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          {isLoading ? <Spinner style={{ margin: 'auto', width: '1.4rem', height: '1.4rem', marginLeft: 4 }} size="sm" /> : <i className="mdi mdi-sitemap"/>}
        </div>
        <span>{t("Flow")}</span>
      </div>
    </Link>
  )
}
